import type {TFunction} from "i18next";

import type {BriefingInboxTableColumnId} from "./briefing-inbox-table-columns";
import type {BriefingManagementTableColumnId} from "./briefing-management-table-columns";

export function tBriefingSearchBySender(tBriefing: TFunction<"briefing">): string {
  return tBriefing("search_by_sender");
}

export function tBriefingValidUntilLabel(tBriefing: TFunction<"briefing">): string {
  return tBriefing("table.valid_until");
}

export function tBriefingRolesLabel(tBriefing: TFunction<"briefing">): string {
  return tBriefing("table.roles");
}

export function tBriefingReadLabel(tBriefing: TFunction<"briefing">): string {
  return tBriefing("table.read");
}

export function tBriefingBriefColumnLabel(tBriefing: TFunction<"briefing">): string {
  return tBriefing("table.briefing");
}

/** Management list columns. */
export function tBriefingManagementColumnLabel(
  columnId: BriefingManagementTableColumnId,
  tBriefing: TFunction<"briefing">,
  tCommon: TFunction<"common">,
): string {
  switch (columnId) {
    case "sent_by":
      return tBriefing("table.sent_by");
    case "sent_at":
      return tBriefing("table.sent_at");
    case "valid_until":
      return tBriefingValidUntilLabel(tBriefing);
    case "properties":
      return tCommon("properties");
    case "roles":
      return tBriefingRolesLabel(tBriefing);
    case "brief":
      return tBriefingBriefColumnLabel(tBriefing);
    case "read":
      return tBriefingReadLabel(tBriefing);
  }
}

/** Inbox list columns. */
export function tBriefingInboxColumnLabel(
  columnId: BriefingInboxTableColumnId,
  tBriefing: TFunction<"briefing">,
  tCommon: TFunction<"common">,
): string {
  switch (columnId) {
    case "sent_at":
      return tBriefing("table.sent_at");
    case "brief":
      return tBriefingBriefColumnLabel(tBriefing);
    case "sent_by":
      return tBriefing("table.sent_by");
    case "status":
      return tCommon("status");
  }
}
